<template>
    <el-dialog title="请选择续方平台" center :visible.sync="dialogVisible">
        <div class="dialog-footer flex space-around">
            <el-button type="primary" @click="handler('his开方')">his续方</el-button>
            <el-button type="primary" @click="handler('平台续方')">平台续方</el-button>
        </div>
    </el-dialog>

</template>

<script>
  export default {
    name: "recipe-dialog",
    props: {
      aspectUser: String,
      type:{
        type:String,
        default:'online'
      }
    },
    data() {
      return {
        dialogVisible: false,
        form: {
          systemScore: ''
        }
      }
    },
    methods: {
      show() {
        this.dialogVisible = true;
      },
      hide() {
        this.dialogVisible = false;
      },
      handler(name) {
        this.$emit('handler',name);
        this.hide();
      },
    },
  }
</script>

<style scoped>

</style>
